<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="Conceptos por Rango" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                @action="masterAction"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
            <g-lookup endpoint="coc"
                        :label="$t('Concepto:')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      ref="concepto"
            >
            </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Rango inicio')" v-bind="fiOptions">
                <a-input-number
                  v-decorator="['r_since', { rules: [{ required: false}] }]"
                  style="width: 100%">
                </a-input-number>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Rango fin')" v-bind="fiOptions">
                <a-input-number
                  v-decorator="['r_to', { rules: [{ required: false}] }]"
                  style="width: 100%">
                </a-input-number>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Desde')" v-bind="fiOptions">
                <a-select
                  v-decorator="[
                    'since_in',
                    { rules: [{ required: false, message: 'Valor requerido' }]},
                  ]"
                >
                  <a-select-option value="S">
                    S
                  </a-select-option>
                  <a-select-option value="N">
                    N
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Hasta')" v-bind="fiOptions">
                <a-select
                  v-decorator="[
                    'to_in',
                    { rules: [{ required: false, message: 'Valor requerido' }]},
                  ]"
                >
                  <a-select-option value="S">
                    S
                  </a-select-option>
                  <a-select-option value="N">
                    N
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Valor')" v-bind="fiOptions">
                <a-input-number
                  v-decorator="['value', { rules: [{ required: false}] }]"
                  style="width: 100%">
                </a-input-number>
              </a-form-item>
            </a-col>

          </a-row>
        </template>
      </g-master>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  export default {
    data () {
      return {
        pageTitle: 'Gestion Rango Conceptos',
        fiOptions: {
          'label-col': {span: 4},
          'wrapper-col': {span: 20},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'coc_range',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Rango inicio', dataIndex: 'r_since', sorter: true},
              {title: 'Rango fin', dataIndex: 'r_to', sorter: true},
              {title: 'Desde', dataIndex: 'since_in', sorter: true},
              {title: 'Hasta', dataIndex: 'to_in', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_coc'},
            {name: 'r_since'},
            {name: 'r_to'},
            {name: 'since_in'},
            {name: 'to_in'},
            {name: 'value'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            console.log('Entro........... ' + action.record.id_coc)
            if (!this.$isEmpty(action.record.id_coc)) {
              this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Calendario/CocRange.vue